import ProductsError from './ProductsError.js'

export default class GetAdProductsError extends ProductsError {}
